import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import Select from '../Select'

const items = [{
  label: 'Monthly',
  value: 'monthly'
}, {
  label: 'Weekly',
  value: 'weekly'
}, {
  label: 'Daily',
  value: 'daily'
// }, {
//   label: 'Hourly',
//   value: 'hourly',
//   intraday: true
// }, {
//   label: '10 minute',
//   value: '10-minute',
//   intraday: true
// }, {
//   label: 'Minute',
//   value: 'minute',
//   intraday: true
}]

@inject('store') @observer
class Frequency extends Component {
  changeBarSize = (e) => {
    const value = e.target.getAttribute('value')
    const action = () => {
      this.props.store.analysis.changeBarSize(value)
      this.props.store.analysis.loadCandlestick()
    }
    if (items.find(item => item.value === value).intraday) {
      const permission = this.props.store.analysis.has_coins ? 'lab.fx_intraday.use' : 'lab.equity_intraday.use'
      this.props.store.permissions.wrap(permission, action)
    } else {
      action()
    }
  }
  render() {
    const {analysis} = this.props.store
    const label = items.find(item => item.value === analysis.bar_size).label
    return(
      <Select
        label={label}
        onSelect={this.changeBarSize}
        items={items}
      />
    )
  }
}

export default Frequency
